import { render, staticRenderFns } from "./NewRechargeBonus.vue?vue&type=template&id=32e599a1&scoped=true&"
import script from "./NewRechargeBonus.vue?vue&type=script&lang=js&"
export * from "./NewRechargeBonus.vue?vue&type=script&lang=js&"
import style0 from "./NewRechargeBonus.vue?vue&type=style&index=0&id=32e599a1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e599a1",
  null
  
)

export default component.exports